import * as React from 'react';
import SuperCritical from 'lib/supercritical';

import { AmenityListMgmt } from './model';
import { OrgHeaderView } from 'portcall/orgprofile/orgheaderview';
import { OrderableLookupsView } from 'portcall/orderablelookups/view';

export const AmenityListMgmtView = SuperCritical(({ model: m } : { model : AmenityListMgmt }) => {
    return (
        <div className="amenitylistmgmt pc-page-fixedwidth">
            <div className="pc-actions-links-header">
                <a className="pc-back-link" href={'#!orgprofile?id=' + m.Model.Id()}>&lt;&lt; Back to Organization</a>
            </div>
            <OrgHeaderView organization={m.Model} />
            <div className="page-body pc-card">
                <div className="amenitytypes">
                    <h2 className="pc-card-title lookup-section-title">Amenity List Management</h2>
                    <div className="lookup-description pc-text-smalllabel">
                        List all of the amenities offered at your berths. You will select amenities from this 
                        list on a berth’s profile. Click +Add Amenities to create a new line item. Click Edit 
                        to change the Type or Details of an amenity.
                    </div>
                    <OrderableLookupsView
                        model={m.OrderableLookups}
                        columns={[{
                            type: 'textInput',
                            title: 'Name',
                            className: 'name',
                            validationKey: 'Name',
                            itemProp: a => a.Name
                        }, {
                            type: 'textInput',
                            title: 'Description',
                            className: 'description',
                            validationKey: 'Description',
                            itemProp: a => a.Description
                        }]}
                        addBtnText="+Add Amenity"
                    />
                </div>
            </div>
        </div>
    );
});



// WEBPACK FOOTER //
// ./apps/portcall/amenitylistmgmt/view.tsx